import { createApp } from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import store from '@/store/store'
import router from '@/router/index'
import timeago from 'vue-timeago3'
import { loadFonts } from '@/plugins/webfontloader'
import VueApexCharts from "vue3-apexcharts"

// Styles
import '@/assets/styles/global.css';

import { i18n } from "@/scripts/i18n";

// Custom functions
import '@/scripts/Globals';

loadFonts()

createApp(App)
  .use(store)
  .use(router)
  .use(timeago)
  .use(vuetify)
  .use(VueApexCharts)
  .use(i18n)
  .mount('#app')
